module.exports = __webpack_public_path__ + "media/public/img/london-eye-logo-1b00f934bb6a62cc960549e4c0c8f0f5.svg";